import { render, staticRenderFns } from "./SchoolAccountResetPasswordPage.vue?vue&type=template&id=25e3444e&scoped=true"
import script from "./SchoolAccountResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./SchoolAccountResetPasswordPage.vue?vue&type=script&lang=ts"
import style0 from "./SchoolAccountResetPasswordPage.vue?vue&type=style&index=0&id=25e3444e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25e3444e",
  null
  
)

export default component.exports